import {
    isArray,
    isFunction,
    isEasyObject,
    isFileList
} from "./main";
import {
    deepMixin
} from "./obj";

export function json2formDataArr(data, keyPrefix) {

    function value2arr(value, keyPrefix) {
        if ( !keyPrefix ) {
            keyPrefix = "";
        }

        let out = [];


        let i = 0;


        let n;


        let val;

        if ( isFileList(value) ) {
            i = 0;
            n = value.length;
            val = false;

            for (; i < n; i++) {
                val = value[i];
                out = out.concat(value2arr(val, keyPrefix + "[]"));
            }
        }
        else if ( isArray(value) ) {
            i = 0;
            n = value.length;
            val = false;

            for (; i < n; i++) {
                val = value[i];
                out = out.concat(value2arr(val, keyPrefix + "[]"));
            }
        }
        else if ( isEasyObject(value) ) {
            out = out.concat(json2formDataArr(value, keyPrefix));
        }
        else {
            out.push({
                key: keyPrefix,
                value
            });
        }

        return out;
    }

    if ( !keyPrefix ) {
        keyPrefix = "";
    }

    let out = [];
    for (let key in data) {
        if ( keyPrefix ) {
            out = out.concat(value2arr(data[key], keyPrefix + "[" + key + "]"));
        } else {
            out = out.concat(value2arr(data[key], key));
        }
    }

    return out;
}

export function http_build_query(formdata, arg_separator) {

    let value; let key; let tmp = [];

    let _http_build_query_helper = function(key, val, arg_separator) {
        let k; let tmp = [];
        if ( val === true ) {
            val = "1";
        } else if ( val === false ) {
            val = "0";
        }
        if ( val != null ) {
            if ( typeof val === "object" ) {
                for (k in val) {
                    if ( val[k] != null ) {
                        tmp.push(_http_build_query_helper(key + "[" + k + "]", val[k], arg_separator));
                    }
                }
                return tmp.join(arg_separator);
            } else if ( typeof val !== "function" ) {
                return encodeURIComponent(key) + "=" + encodeURIComponent(val);
            } else {
                throw new Error("There was an error processing for http_build_query().");
            }
        } else {
            return "";
        }
    };

    if ( !arg_separator ) {
        arg_separator = "&";
    }
    for (key in formdata) {
        value = formdata[key];
        let query = _http_build_query_helper(key, value, arg_separator);
        if ( query !== "" ) {
            tmp.push(query);
        }
    }

    return tmp.join(arg_separator);
}

// http://javascript.ru/ajax/intro
export function getXHR() {
    let xmlhttp;
    try {
        xmlhttp = new ActiveXObject("Msxml2.XMLHTTP");
    } catch (e) {
        try {
            xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
        } catch (E) {
            xmlhttp = false;
        }
    }
    if ( !xmlhttp && typeof XMLHttpRequest != "undefined" ) {
        xmlhttp = new XMLHttpRequest();
    }
    return xmlhttp;
}

export function ajax(params) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(params.method, params.url);

        xhr.onreadystatechange = () => {
            if ( xhr.readyState != 4 ) {
                return;
            }

            if ( xhr.status !== 200 ) reject(xhr);
            else resolve(xhr);
        };

        xhr.send();
    });
}

export async function tryLoadJson(url, defaultJson = {}) {
    try {
        const {responseText} = await ajax({
            method: "GET", url
        });
        const json = JSON.parse(responseText);
        return json;
    } catch {
        return defaultJson;
    }
}

export function ajaxSend(params) {
    if ( !window.FormData ) {
        return;
    }

    if ( arguments.length > 1 ) {
        params = {
            method: params,
            url: arguments[1],
            data: arguments[2],
            onSuccess: arguments[3],
            onError: arguments[4]
        };
    }

    params = deepMixin({
        headers: {},
        noConsoleError: false,
        method: "POST",
        url: "_blank.html",
        data: {},
        onSuccess() {},
        onError() {},
        onProgress() {},
        onUploadProgress() {},
        initAbort() {}
    }, params);

    let onSuccess = params.onSuccess;
    let onError = params.onError;
    let onProgress = params.onProgress;
    let onUploadProgress = params.onUploadProgress;
    let initAbort = params.initAbort;
    let data = params.data;
    let url = params.url;
    let method = params.method;

    if ( !isFunction(onSuccess) ) {
        onSuccess = function() {};
    }

    if ( !isFunction(onError) ) {
        onError = function() {};
    }

    if ( !isFunction(onProgress) ) {
        onProgress = function() {};
    }

    if ( !isFunction(onUploadProgress) ) {
        onUploadProgress = function() {};
    }

    if ( !isFunction(initAbort) ) {
        initAbort = function() {};
    }

    let xhr = getXHR();


    let formData = new FormData();


    let values = json2formDataArr(data);

    values.forEach(function(elem) {
        formData.append(elem.key, elem.value);
    });

    xhr.open(method, url);

    // token
    for (let key in params.headers) {
        xhr.setRequestHeader(key, params.headers[key]);
    }

    xhr.onreadystatechange = function() {
        if ( xhr.readyState != 4 ) {
            return;
        }

        if ( xhr.status != 200 ) {
            onError(xhr);
        } else {
            let response = xhr.responseText;
            let json = {};
            try {
                json = $.parseJSON(response);
            } catch (e) {
                json = {};
                if ( !params.noConsoleError ) {
                    console.error(e);
                }
            }

            onSuccess(json);
        }
    };

    // ie
    try {
        xhr.onprogress = onProgress;
        xhr.upload.onprogress = onUploadProgress;
    } catch (err) {
        console.error(err);
    }

    initAbort(function() {
        xhr.abort();
    });

    xhr.send(formData);
}
